import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";

import { useDispatch, useSelector } from "react-redux";
import { redeemApi } from "../../app/slices/redeemSliceFintso";
import { toast } from "react-toastify";
import NameDateSearchComponent from "../../components/customTable/NameDateSearchComponent";


export default function Sell() {
  const columnHelper = createMRTColumnHelper();
  const sliceResponse = useSelector((state) => state.redeemSlice.redeem.data);
  const stateLoading = useSelector(
    (state) => state.redeemSlice.loading
  );


  const [showData, setShowData] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((originalData) => ({
        id: originalData._id,
        customerRefNo: originalData.customerRefNo || "N/A",
        quantity: originalData.quantity || "N/A",
        metalType: originalData.metalType || "N/A",
        partnerId: originalData.partner_id || "N/A",
        partnerUsername: originalData.partner_username || "N/A",
        createdAt: originalData.createdAt || "N/A",
        updatedAt: originalData.updatedAt || "N/A",
        orderId: originalData.result?.data?.orderId || "N/A",
        merchantTransactionId:
          originalData.result?.data?.merchantTransactionId || "N/A",
        shippingCharges: originalData.result?.data?.shippingCharges || "N/A",
        goldBalance: originalData.result?.data?.goldBalance || "N/A",
        silverBalance: originalData.result?.data?.silverBalance || "N/A",
      }));

      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);
  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),

    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId
          );
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("goldBalance", {
      header: "Gold Balance",
      size: 30,
    }),
    columnHelper.accessor("silverBalance", {
      header: "Silver Balance",
      size: 30,
    }),
    columnHelper.accessor("shippingCharges", {
      header: "Shipping Charges",
      size: 30,
    }),
    columnHelper.accessor("orderId", {
      header: "Order ID",
      size: 30,
    }),
    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.partnerId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  const dispatch = useDispatch();

  // Local state to manage search terms
  // const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchAadharData = useCallback(() => {
    // setLoading(true);

    let params = {};
    // if (searchTerm) {
    params.name = queryParams.customerName;
    // } else if (queryParams.startDate && queryParams.endDate) {
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    // }

    if (Object.keys(params).length > 0) {
      dispatch(redeemApi(params)); // Dispatch API call even when reset (empty search term or date)
    }

    // setLoading(false);
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchAadharData();
  }, [fetchAadharData]);

  // Function to handle date search
  const handleSearchByDate = (startDate, endDate, customerName) => {
    // setLoading(true);

    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <>
     {/*  */}
      <Box>
        <Box>
          <Box
            mt={2}
            mb={2}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <NameDateSearchComponent onSearch={handleSearchByDate} />
          </Box>
        </Box>
        <Box sx={{ margin: "auto" }}>
          <CustomTable columns={columns} data={showData} loading={stateLoading} permissionKey="fintsoTransactions"/>

        </Box>
      </Box>
    </>
  );
}
